// @flow
import React, { PureComponent, Fragment } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { getPublicAssets } from 'utils/assetsUtils';
import type { ThemeType } from 'types/Faq';
import type { BlocFaq } from 'types/Settings';
import CardThumbnail from 'components/fragments/card/CardThumbnail';
import Breadcrumb from 'components/fragments/Breadcrumb';
import ContactList from 'containers/contact/ContactListContainer';
import { Link } from 'react-router-dom';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  themes?: Array<ThemeType>,
  blocs_faq: Array<BlocFaq>
};

export type DispatchProps = {
  fetchThemes: () => void,
  fetchQuestions: () => void
};

type Props = {
  history: any,
  location: any,
  match: {
    params: {
      slugTheme: string
    }
  }
} & DispatchProps &
StateProps;

type State = {
  isOpen: boolean,
  object: string
};

class ContactWrapper extends PureComponent<Props, State> {
  static defaultProps = {
    themes: [],
    form: false
  };
  state: State = {
    isOpen: false,
    object: ''
  }

  componentDidMount() {
    const {
      location: { state: locationState },
    } = this.props;
    this.props.fetchThemes();
    this.props.fetchQuestions();
    if (locationState) {
      const { object } = locationState;
      if (object) {
        this.setState({ object });
      }
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const {
      location: { state: locationState },
    } = this.props;
    if (prevState.isOpen === this.state.isOpen) {
      this.setState({
        isOpen: false
      });
    }
    if (locationState) {
      const { object } = locationState;
      this.setState({ object });
    } else {
      this.setState({ object: '' });
    }
  }

  handleOnChange = (e: Event) => {
    if (e.target instanceof HTMLSelectElement) {
      this.props.history.push(`/contact/${e.target.value}`);
    }
  };

  handleClickDropDown = (e: MouseEvent) => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  renderCardThumbnail = () => {
    const { blocs_faq } = this.props;

    return blocs_faq.map((thumbnail, index) => {
      let url = '';
      if (thumbnail.parent_slugs[1]) {
        url = `${thumbnail.parent_slugs[1]}/`;
      }
      if (thumbnail.parent_slugs[2]) {
        url = `${url}${thumbnail.parent_slugs[2]}/`;
      }
      url = `${url}${thumbnail.object_slug}`;
      return (
        <div key={index} className="col col-md-4 col-lg-4 mb-2 mb-md-4 mb-lg-4">
          <CardThumbnail
            url={`/${url}`}
            backgroundUrl={thumbnail.featured_image}
            title={thumbnail.title}
            desc={thumbnail.description}
            linkLabel={thumbnail.texte_cta} />
        </div>
      );
    });
  };

  renderSelect = () => {
    const { match: { params: { slugTheme } }, themes } = this.props;
    const { isOpen, object } = this.state;
    let label = 'Choisir un sujet';

    const classNames = dynamicClassName('mt-5 dropdown dropdown--contact');
    isOpen && classNames.add('is-open');
    if (object && themes && themes.length > 0) {
      label = object;
    } else if (slugTheme && themes && themes.length > 0) {
      if (slugTheme === 'nous-contacter') {
        label = 'Contacter la Fédération';
      } else {
        const selectedTheme = themes.filter(theme => theme.slug === slugTheme);

        if (selectedTheme && selectedTheme.length > 0) {
          label = selectedTheme[0].name;
        }
      }
    }

    if (themes) {
      return (
        <div className={classNames.build()}>
          <span className="dropdown__head ft-h6 ft-up" role="button" tabIndex={0} onClick={this.handleClickDropDown}>
            <span className="dropdown__label">{label}</span>
          </span>
          <div className="dropdown__list">
            <span className="dropdown__head ft-h6 ft-up"
              role="menuitem"
              tabIndex={0}
              onClick={this.handleClickDropDown}>
              <span className="dropdown__label">{label}</span>
            </span>
            <div className="dropdown__wrapper">
              {themes.map((theme, index) => {
                return (
                  <Link
                    key={index}
                    title={theme.name}
                    to={`/contact/${theme.slug}`}>
                    {theme.name}
                  </Link>
                );
              })}
              <Link
                title='Contacter la Fédération'
                to={`/contact/nous-contacter`}>
                Contacter la Fédération
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    const { slugTheme } = this.props.match.params;

    return (
      <Fragment>
        <section className="banner banner--big banner--center">
          <div className="banner__thumbnail img-blue-dark"
            style={{ backgroundImage: `url(${getPublicAssets('/img/banner/faq.jpg')})` }} />
          <div className="container">
            <Breadcrumb breadcrumbStyle="" elements={[{ name: 'Accueil', to: '/' }, 'Nous contacter']} isDark={true} />
            <h1 className="ft-h2">Nous contacter</h1>
            <p className="banner__desc">
              La Fédération se tient à votre disposition pour répondre à toutes vos questions.
              À quel sujet pouvons-nous vous aider ?
            </p>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-lg-8 col-lg-offset-2">
              {this.renderSelect()}
            </div>
          </div>
          {slugTheme ? <ContactList /> : null}
          <div className="row mb-6 mb-md-7 mb-lg-8 mt-8">{this.renderCardThumbnail()}</div>
        </div>
      </Fragment>
    );
  }
}

export default withHelmet(ContactWrapper)((Helmet, pageProps) => {
  const meta = getMetaBySlug(pageProps.location.pathname);
  return (
    <Helmet>
      <title>{meta.title()}</title>
      <meta name={'description'} content={meta.description()} />
      <meta property={'og:title'} content={meta.title()} />
      <meta property={'og:description'} content={meta.description()} />
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
